/**
 * selectWabaIdFromEndpoint
 *
 * Regra de negócio (contrato do feature):
 * - Sempre usar o `contact.rank === 1`.
 * - Buscar `extension.url === "https://fluxmed.com.br/fhir/StructureDefinition/waba-id"`.
 * - Retornar o `valueString`.
 *
 * Observação:
 * - Mantemos a função pura para facilitar testes e evitar acoplamento com clients FHIR.
 */

const WABA_ID_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/waba-id";

const PHONE_NUMBER_ID_EXTENSION_URL =
  "https://fluxmed.com.br/fhir/StructureDefinition/whatsapp-phone-number-id";

export function selectWabaIdFromEndpoint(endpoint: fhir5.Endpoint): string | null {
  const contacts = endpoint.contact ?? [];
  const rankOneContact = contacts.find((contact) => contact.rank === 1);
  if (!rankOneContact) return null;

  const extensions = rankOneContact.extension ?? [];
  const wabaExtension = extensions.find(
    (extension) => extension.url === WABA_ID_EXTENSION_URL,
  );

  return typeof wabaExtension?.valueString === "string" &&
    wabaExtension.valueString.trim()
    ? wabaExtension.valueString.trim()
    : null;
}

/**
 * selectPhoneNumberIdFromEndpoint
 *
 * Regra de negócio (contrato do feature):
 * - Sempre usar o `contact.rank === 1`.
 * - Buscar `extension.url === "https://fluxmed.com.br/fhir/StructureDefinition/whatsapp-phone-number-id"`.
 * - Retornar o `valueString`.
 *
 * Observação:
 * - Mantemos a função pura para facilitar testes e evitar acoplamento com clients FHIR.
 */
export function selectPhoneNumberIdFromEndpoint(
  endpoint: fhir5.Endpoint,
): string | null {
  const contacts = endpoint.contact ?? [];
  const rankOneContact = contacts.find((contact) => contact.rank === 1);
  if (!rankOneContact) return null;

  const extensions = rankOneContact.extension ?? [];
  const phoneNumberIdExtension = extensions.find(
    (extension) => extension.url === PHONE_NUMBER_ID_EXTENSION_URL,
  );

  return typeof phoneNumberIdExtension?.valueString === "string" &&
    phoneNumberIdExtension.valueString.trim()
    ? phoneNumberIdExtension.valueString.trim()
    : null;
}

export const messagingConstants = {
  WABA_ID_EXTENSION_URL,
  PHONE_NUMBER_ID_EXTENSION_URL,
};

